import type { FC } from 'react';
import { lazy } from 'react';
import type { ContractManagementShipperRequest } from 'src/apis/contract-management/use-contract-management-shipper';

const Page = lazy(() => import('./page'));

type Props = {
  shipperName: string;
  contractManagementShipper?: ContractManagementShipperRequest;
};

export const ShipperFinancialSecurities: FC<Props> = ({
  contractManagementShipper,
  shipperName,
}) => {
  if (
    !contractManagementShipper?.response?.data ||
    !contractManagementShipper.response.data._links.getFinancialSecurities
  )
    return null;

  return (
    <Page
      shipperName={shipperName}
      contractManagementShipper={contractManagementShipper}
    />
  );
};
